import '../../styles/skeleton.scss'

type SkeletonLoaderProps = {
  count?: number;
  height?: string;
  gap?: string;
  borderRadius?:string
};

const SkeletonLoader = ({ count = 3, height = '16px', gap = '8px', borderRadius='10px' }: SkeletonLoaderProps) => {
  const widths = ['87%', '90%', '93%','97%'];

  return (
    <div className="defaultskeleton">
      <div className="centerdev skeleton" style={{ display: 'flex', flexDirection: 'column' }}>
        {Array.from({ length: count }).map((_, idx) => {
          const width = widths[Math.floor(Math.random() * widths.length)];
          return (
            <div
              key={idx}
              className="bar"
              style={{
                width
              }}
            />
          );
        })}
      </div>
    </div>
  );
};

export default SkeletonLoader;
